const INPUT_TAGS = new Set(["INPUT", "TEXTAREA", "SELECT"]);

/**
 * True iff focus is on a form input (or contentEditable) outside the given
 * container. Hooks that scope a keyboard shortcut to a panel/modal use this
 * to avoid stealing keypresses meant for unrelated form fields elsewhere on
 * the page. Pass `null` to check "any form input has focus".
 */
export function isTypingInExternalInput(container) {
  const el = document.activeElement;
  if (!el) return false;
  if (container && container.contains(el)) return false;
  if (INPUT_TAGS.has(el.tagName)) return true;
  if (el.isContentEditable) return true;
  return false;
}

/**
 * Determines whether a key event should be ignored based on the target element's properties.
 *
 * This function checks for the following conditions:
 * 1. If the target or its ancestors have the `data-keyboard-capture` attribute
 * 2. If the target or its ancestors have `contenteditable="true"`
 * 3. If the target element is a `TEXTAREA`, `INPUT`, or `SELECT`
 */
export function shouldIgnoreKeyEvent(event) {
  const excludedTags = ["TEXTAREA", "INPUT", "SELECT"];

  let targetElement = event.target;
  while (targetElement != null) {
    if (targetElement.hasAttribute("data-keyboard-capture")) {
      return true;
    }

    if (targetElement.getAttribute("contenteditable") === "true") {
      return true;
    }

    targetElement = targetElement.parentElement;
  }

  if (excludedTags.includes(event.target.tagName.toUpperCase())) {
    return true;
  }

  return false;
}
